import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroBanner from '@/components/feature/HeroBanner';
import CategorySection from './components/CategorySection';
import HotSection from './components/HotSection';
import LatestSection from './components/LatestSection';
import FeaturedSection from './components/FeaturedSection';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '悟空影视',
  url: 'https://www.wukongmovies.com',
  description: '悟空影视电影大全涵盖悟空影视最新电影、动作片、喜剧片等海量题材。高清画质免费在线观看，无需缓冲即点即播。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://www.wukongmovies.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '悟空影视',
  url: 'https://www.wukongmovies.com',
  description: '悟空影视 - 高清电影免费在线观看平台',
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'service@wukongmovies.com',
    contactType: 'customer service',
  },
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgJsonLd) }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroBanner />
          <CategorySection />
          <HotSection />
          <FeaturedSection />
          <LatestSection />
          <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
            <div className="rounded-2xl bg-gradient-to-r from-background-200 to-background-100 p-8 md:p-12 text-center border border-background-300/40">
              <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
                随时随地，畅享高清电影
              </h2>
              <p className="text-sm md:text-base text-foreground-600 mb-6 max-w-2xl mx-auto leading-relaxed">
                悟空影视支持电脑、平板、手机多端同步观看。无论您身在何处，打开悟空影视，海量好片即刻呈现。
              </p>
              <div className="flex items-center justify-center gap-4 md:gap-8 flex-wrap">
                <div className="flex items-center gap-2 text-foreground-700">
                  <i className="ri-computer-line text-lg text-accent-500"></i>
                  <span className="text-sm">电脑端</span>
                </div>
                <div className="flex items-center gap-2 text-foreground-700">
                  <i className="ri-tablet-line text-lg text-accent-500"></i>
                  <span className="text-sm">平板端</span>
                </div>
                <div className="flex items-center gap-2 text-foreground-700">
                  <i className="ri-smartphone-line text-lg text-accent-500"></i>
                  <span className="text-sm">手机端</span>
                </div>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}